import { render } from "./HeroiconsSolidX.vue?vue&type=template&id=91a3df90"
const script = {}

import exportComponent from "/data/aabpcpds/mnghaniix/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsSolidX.vue"]])

export default __exports__